export default __webpack_public_path__ + "static/media/category_am.f3ebce76.svg";